var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.808 28.875zm.223-.033V19.76h3.03l.575-3.76h-3.605v-2.438c0-1.027.503-2.03 2.119-2.03h1.64v-3.2s-1.488-.254-2.91-.254c-2.97 0-4.911 1.799-4.911 5.058V16h-3.302v3.759h3.302v9.083C7.754 27.867 3 22.49 3 16 3 8.82 8.82 3 16 3s13 5.82 13 13c0 6.489-4.754 11.867-10.969 12.842z",
    fill: "#1d1e1f",
    fillRule: "evenodd"
  })));
};
export default SvgFacebook;